import BaseScene from './BaseScene'
import { RefereeSpeed, BrownianSpeed, WalkSpeed } from './Constants'
import {randomInteger, delay} from '../helper'
import * as sounds from '../../../constants/Sounds'

export default class YellowCard extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        this.Team = event.team;
        this.Player = event.player;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            
            let referee = this.Pitch.referee.getWrappedInstance();
            let player = this.GetPlayer(this.Team, this.Player);

            this.HighLightPlayers([player]);

            player.BrownianMovement(gameSpeed);
            let refereeMovements = referee.OvertakeOtherPlayer(player, gameSpeed, RefereeSpeed*2)
                .then(()=> referee.BrownianMovement(gameSpeed, 40))
                .then(() => {player.HasYellowCard = true})
                .then(()=> player.BrownianMovement(gameSpeed, 40));


            this.getPlayers( (p)=> !this.PlayerIn(p, [player]))
                .forEach((player)=> {
                    player.BrownianMovement(gameSpeed, randomInteger(30, 60))
                        .then(()=> player.WalkToNextPosition(gameSpeed, WalkSpeed));
                });
            
            Promise.all([refereeMovements]).then(()=> {
                player.WalkToNextPosition(gameSpeed, WalkSpeed);
                referee.OvertakeBall();
                delay(80*gameSpeed).then(resolve)
            });

        }.bind(this));
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/YellowCard.js
 **/